<template>
    <v-card flat tile outlined v-bind="$attrs">
        <v-card-title>
            <template v-if="title">
                <div>
                    {{ (actions && !crud) && $t(title.slice(0, -1)) || $t(title) }}
                </div>

                <v-spacer v-if="crud || search != undefined" />

                <v-text-field class="search-field" v-if="search != undefined" @input="searchChanged" :value="search"
                    :placeholder="$t('searchPlaceholder')" prepend-inner-icon="mdi-magnify" />

                <Btn v-if="crud" :disabled="disabled" icon="plus" :title="$t('add') + ' ' + $t(title.slice(0, -1))"
                    color="primary" @click="add" />

            </template>
            <slot v-else name="title"></slot>
        </v-card-title>

        <v-card-text>
            <slot></slot>
        </v-card-text>
        <v-card-actions>
            <template v-if="actions">
                <Btn color="primary" @click="save" :disabled="!isFormValid" :title="$t('save')" />
                <Btn color="error" @click="cancel" :title="$t('cancel')" />
            </template>
            <slot v-else name="actions"></slot>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'Card',
    props: {
        title: String,
        actions: Boolean,
        crud: Boolean,
        disabled: Boolean,
        search: String,
        isFormValid: Boolean
    },
    methods: {
        add() {
            this.$emit('add');
        },
        save() {
            this.$emit('save');
        },
        cancel() {
            this.$emit('cancel');
        },
        searchChanged(event) {
            this.$emit('search', event)
        }
    }
}
</script>

<style scoped>
.search-field {
    max-width: 200px;
}
</style>